export default __webpack_public_path__ + "static/media/signal.e8a130a2.mp3";